import { CancelSmall, Check, Plus } from '@app/components/various/Icons';
import cx from 'classnames';
import React from 'react';

import styles from './Pills.module.scss';

interface Props {
  value?: string;
  isChecked?: boolean;
  disabled?: boolean;
  onBlur?: () => void;
  onChange?: (isChecked: boolean, value?: string) => void;
}

export const Pill = ({ value, isChecked = false, disabled = false, children, onBlur, onChange }: React.WithChildren<Props>) => {
  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(event.target.checked, value);
    },
    [onChange, value],
  );

  const icon = isChecked ? <Check className={styles.icon} /> : <Plus className={styles.icon} />;

  return (
    <>
      <input
        type="checkbox"
        id={value}
        value={value}
        disabled={disabled}
        className={cx('sr-only', styles.input)}
        checked={isChecked}
        onBlur={onBlur}
        onChange={handleChange}
      />
      <label htmlFor={value} className={styles.pill}>
        {icon}
        {children}
        {isChecked && !disabled && <CancelSmall className={styles.icon} />}
      </label>
    </>
  );
};
